import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
   selector: 'samweb-dialog-tooltip',
   templateUrl: './dialog-tooltip.component.html',
   styleUrls: ['./dialog-tooltip.component.scss'],
})
export class DialogTooltipComponent {
   @Input()
   public isDialogOpen: boolean;

   @Output()
   public dialogClosed = new EventEmitter<any>();

   closeDialog(event) {
      this.dialogClosed.emit(event);
   }
}
